export default __webpack_public_path__ + "static/media/arrow-top-left.b33ee9f6.svg";